import {
  getPaymentPlan,
  getPriceAndFrequency,
  PackagePrice,
} from "../../packagePricing";
import {
  DEFAULT_CONTRACT_MONTHS,
  getAddonContractTotal,
  getAddonInstalmentIncrement,
  toSelectedAddons,
} from "./addonPricing";

// Checkout still posts the package amount and the server adds the add-ons it saved, so this
// only has to show the client the total they are about to be charged.
export const getPriceAndFrequencyWithAddons = (
  selectedPackage: any
): PackagePrice => {
  const base = getPriceAndFrequency(
    selectedPackage?.payment_terms,
    selectedPackage?.total_amount
  );
  const addons = toSelectedAddons(selectedPackage?.selected_addons);
  if (addons.length === 0) {
    return base;
  }

  const plan = getPaymentPlan(
    selectedPackage?.payment_terms,
    selectedPackage?.total_amount
  );
  const months =
    Number(selectedPackage?.contract_months) || DEFAULT_CONTRACT_MONTHS;
  const increment = plan.recurring
    ? getAddonInstalmentIncrement(addons, plan.paymentTerm, months)
    : getAddonContractTotal(addons, months);

  return { ...base, price: Math.round(base.price) + increment };
};
